export const MODULE_NAME = 'holdingPage';
